import GenericListComponentTanStack from './GenericListComponentTanStack';

export default function AdminProducts() {
  return (
    <GenericListComponentTanStack
      name='product'
      columns={[
        { accessor: 'id', title: 'ID' },
        { accessor: 'name', title: 'Name' },
        { accessor: 'image', title: 'Image' },
        { accessor: 'is_enabled', title: 'Active' },
      ]}
    />
  );
}
